
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-5c7d543b&scoped=true!sass-loader?sourceMap!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./EmptyList.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./EmptyList.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-5c7d543b!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./EmptyList.vue"),
  /* scopeId */
  "data-v-5c7d543b",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/components/list/EmptyList.vue
// module id = 24
// module chunks = 2